<template>
    <div>
        <nav-bar></nav-bar>
        <div class="content">
            <nav-left-bar :active="0"></nav-left-bar>
            <div class="rg">
                <div class="tit">
                    <div class="l">
                        <img src="../../assets/icon/bg.png" alt="" />
                        <div class="tc">
                            {{ meeting_info.name }}
                        </div>
                    </div>
                </div>
                <div class="details">
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">
                            {{ meeting_info.name }}
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="lk">
                        <img src="../../assets/icon/details_2.png" alt="" />
                        <div>会议室归属：{{ meeting_info.section_name }}</div>
                    </div>
                    <div class="lk">
                        <img src="../../assets/icon/details_2.png" alt="" />
                        <div>会议室位置：{{ meeting_info.address }}</div>
                    </div>
                    <div class="lk">
                        <img src="../../assets/icon/details_3.png" alt="" />
                        <div>会议室描述：{{ meeting_info.content }}</div>
                    </div>
                    <div class="lk">
                        <img src="../../assets/icon/details_1.png" alt="" />
                        <div>
                            会议室管理员：{{ meeting_info.manager_name }}
                        </div>
                    </div>
                    <div style="height:29px"></div>
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">申请信息</div>
                    </div>
                    <div class="line"></div>
                    <div class="lk-input">
                        <label>会议室名称：</label>
                        <input type="text" :value="order_info.name" disabled />
                    </div>
                    <div class="lk-input">
                        <label>预约人：</label>
                        <input
                            type="text"
                            :value="order_info.user_name"
                            disabled
                        />
                    </div>
                    <div class="lk-input">
                        <label>联系方式：</label>
                        <input
                            type="text"
                            :value="order_info.user_phone"
                            disabled
                        />
                    </div>
                    <div class="lk-input">
                        <label>预约主题：</label>
                        <input type="text" :value="order_info.theme" disabled />
                    </div>
                    <div class="lk-input speak">
                        <label>预约说明：</label>
                        <textarea
                            :value="order_info.explain"
                            disabled
                        ></textarea>
                    </div>
                    <div style="height:40px"></div>

                    <div class="lk-input">
                        <label>使用时间：</label>
                        <input
                            type="text"
                            disabled
                            :value="
                                order_info.start_time_text +
                                    '~' +
                                    order_info.end_time_text
                            "
                        />
                    </div>
                    <div style="height:50px"></div>
                    <div class="title">
                        <div class="ricle"></div>
                        <div class="txt">审批流程</div>
                    </div>
                    <div class="line"></div>
                    <div class="table">
                        <table>
                            <tbody>
                                <tr>
                                    <th>审批人·审批中</th>
                                    <th>{{ num }}/1</th>
                                </tr>
                                <tr
                                    v-for="(item, index) in approval_info"
                                    :key="index"
                                >
                                    <td>{{ item.approval_id_text }}</td>
                                    <td v-if="item.is_pass != 2">
                                        {{ item.is_pass_text }} ·
                                        {{ item.confirm_time_text }}
                                    </td>
                                    <td
                                        v-if="item.is_pass == 2"
                                        style="color:#DD1313"
                                    >
                                        {{ item.is_pass_text }} ·
                                        {{ item.reasons }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="delbg">
                        <div class="del" @click="del">删除</div>
                        <div class="btn" @click="back">返回</div>
                    </div>
                    <div style="height:30px;"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "room_appointInformation",
    data() {
        return {
            value: "",
            currentPage: 10,
            show: false,
            order_info: {},
            meeting_info: {},
            approval_info: [],
            num: 0
        };
    },
    methods: {
        clear() {
            this.value = "";
        },
        replay() {
            this.show = true;
        },
        close() {
            this.show = false;
        },
        apply() {
            this.$router.push("/room_appointmentApply");
        },
        back() {
            this.$router.go(-1);
        },
        del() {
            let _this = this;
            _this
                .$confirm("确定要删除当前预约吗?", "温馨提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    _this.$post("/api/person/my_appointment_del", {
                        id: this.$route.query.id
                    })
                        .then(res => {
                            if (res.code == 1) {
                                _this.$toast("删除成功");
                                setTimeout(() => {
                                    _this.$router.go(-1);
                                }, 1500);
                            }
                        })
                        .catch(err => {
                            console.log(err);
                        });
                })
                .catch(() => {});
        },
        details() {
            this.$post("/api/person/my_meeting_appointment_info", {
                id: this.$route.query.id
            })
                .then(res => {
                    if (res.code == 1) {
                        res.data.order_info.end_time_text = res.data.order_info.end_time_text.substring(
                            5,
                            17
                        );
                        this.approval_info = res.data.approval_info;
                        this.meeting_info = res.data.meeting_info;
                        this.order_info = res.data.order_info;
                        this.num = res.data.num;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },
    mounted() {
        this.details();
    }
};
</script>
<style lang="less" scoped>
.content {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 21px;
    display: flex;
    .rg {
        width: 838px;
        height: 80px;
        // line-height: 80px;
        background: #ffffff;
        margin-left: 21px;
        .tit {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .l {
                display: flex;
                height: 100%;
                align-items: center;
                img {
                    width: 5px;
                    height: 24px;
                }
                .tc {
                    font-size: 24px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    color: #333333;
                    padding-left: 13px;
                }
            }
        }
        .details {
            width: 838px;
            height: auto;
            background: #ffffff;
            margin-top: 21px;
            .title {
                display: flex;
                height: 43px;
                align-items: center;
                .ricle {
                    width: 4px;
                    height: 4px;
                    background: #ffffff;
                    border: 3px solid #3449d3;
                    border-radius: 50%;
                    margin-left: 20px;
                }
                .txt {
                    font-size: 18px;
                    font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 500;
                    text-align: left;
                    color: #333333;
                    padding-left: 14px;
                }
            }
            .line {
                width: 793px;
                border: 1px dashed #eaecfa;
                margin-left: 20px;
            }
            .table {
                width: 524px;
                margin-top: 31px;
                margin-left: 45px;
                table {
                    border: 1px solid #f3f5fc;
                    border-collapse: collapse;
                    tbody {
                        tr {
                            height: 50px;
                            border: 1px solid #f3f5fc;
                            th {
                                font-size: 15px;
                                font-family: PingFangSC, PingFangSC-Medium;
                                font-weight: 500;
                                color: #333333;
                                letter-spacing: 0px;
                                border: 1px solid #f3f5fc;
                                background: #f3f5fc;
                            }
                            th:nth-of-type(1) {
                                font-weight: bolder;
                            }
                            th:nth-of-type(2) {
                                text-align: right;
                                padding-right: 20px;
                            }
                            td {
                                font-size: 14px;
                                font-family: PingFang, PingFang-SC;
                                font-weight: SC;
                                text-align: center;
                                color: #333333;
                                border: 1px solid #f3f5fc;
                            }
                            td:nth-of-type(1) {
                                width: 167px;
                            }
                            td:nth-of-type(2) {
                                width: 520px;
                            }
                        }
                    }
                }
            }
            .delbg {
                display: flex;
                height: 44px;
                align-items: center;
                margin-top: 42px;
                .btn {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    color: #ffffff;
                    font-size: 16px;
                    background: #3449d3;
                    border-radius: 5px;
                    margin: 0 auto;
                    cursor: pointer;
                }
                .del {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    color: #ffffff;
                    font-size: 16px;
                    background: #dc3733;
                    border-radius: 5px;
                    margin: 0 auto;
                    cursor: pointer;
                }
            }

            .lk {
                display: flex;
                padding-left: 20px;
                padding-top: 20px;
                img {
                    // width: 18px;
                    height: 18px;
                }
                > div {
                    max-width: 745px;
                    font-size: 16px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #333333;
                    line-height: 20px;
                    padding-left: 14px;
                }
                .eq {
                    width: 290px !important;
                    height: 190px !important;
                    margin-left: 27px;
                    object-fit: cover;
                }
            }

            .lk-input {
                display: flex;
                height: 40px;
                align-items: center;
                padding-left: 45px;
                padding-top: 20px;
                label {
                    width: 92px;
                    font-size: 15px;
                    font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #333333;
                    letter-spacing: 0px;
                }
                input {
                    width: 280px;
                    height: 40px;
                    border: 1px solid #d9ddf1;
                    border-radius: 4px;
                    margin-left: 16px;
                    padding-left: 10px;
                    font-size: 14px;
                    &::placeholder {
                        color: #999999;
                    }
                }
                textarea {
                    width: 332px;
                    height: 76px;
                    border: 1px solid #d9ddf1;
                    border-radius: 4px;
                    margin-left: 15px;
                    margin-top: 40px;
                    font-size: 14px;
                    background: #ffffff;

                    padding: 10px 0 0 8px;
                }
            }

            .zhushi {
                font-size: 16px;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #333333;
                padding: 27px 0 60px 40px;
            }
            .replay {
                display: flex;
                height: 44px;
                align-items: center;
                width: 100%;
                justify-content: center;
                padding-bottom: 60px;
                .left {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #3449d3;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    margin-right: 50px;
                    cursor: pointer;
                }
                .right {
                    width: 346px;
                    height: 44px;
                    line-height: 44px;
                    text-align: center;
                    background: #6480ec;
                    border-radius: 5px;
                    color: #ffffff;
                    font-size: 16px;
                    cursor: pointer;
                }
            }
        }
    }
}
.show {
    position: fixed;
    z-index: 11;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #333333;
    opacity: 0.5;
    width: 100%;
    height: 100%;
}
.close {
    width: 50px;
    height: 50px;
    position: fixed;
    left: 0;
    right: 0;
    z-index: 111;
    bottom: 100px;
    margin: 0 auto;
    cursor: pointer;
}
.ing {
    width: 590px;
    height: 466px;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.19);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 1000;
    .title {
        width: 100%;
        height: 81px;
        line-height: 81px;
        background: #f3f5fc;
        border-radius: 6px 6px 0px 0px;
        text-align: center;
        font-size: 24px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
    }
    .list {
        width: 100%;
        height: 356px;
        overflow-y: scroll;
        // display: flex;
        flex-direction: column;
        align-items: center;
        display: -webkit-inline-box;
        .li {
            width: 510px;
            display: flex;
            height: 80px;
            align-items: center;
            border-bottom: 1px solid #f8f8f8;
            .time {
                font-size: 20px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                color: #333333;
                letter-spacing: 0px;
            }
            .con {
                font-size: 18px;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 400;
                color: #333333;
                letter-spacing: 0px;
                padding-left: 30px;
            }
            img {
                width: 69px;
                height: 25px;
                margin-left: 30px;
            }
        }
    }
}
</style>
